if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.threshold = parseFloat(this.dataset.threshold) * 100;
        this.currencySymbol = this.dataset.currencySymbol;
        this.messageElement = this.querySelector('[data-message-text]');
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.progressMessageContainer = this.querySelector('[data-progress-message]');
        this.successMessageContainer = this.querySelector('[data-success-message]');

        this.updateProgress();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.updateProgress());
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      updateProgress() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const cartTotal = cart.total_price;
            const remaining = this.threshold - cartTotal;
            const percentage = Math.min((cartTotal / this.threshold) * 100, 100);

            this.progressBar.setAttribute('data-percentage', percentage);
            this.progressBar.style.backgroundImage =
              'linear-gradient(to right, #334fb4 0%, #334fb4 ' +
              percentage +
              '%, #cccccc ' +
              percentage +
              '%, #cccccc 100%)';

            if (remaining <= 0) {
              this.progressBar.classList.add('free-shipping-bar__complete');
              this.progressMessageContainer.classList.add('free-shipping-bar__hidden');
              this.successMessageContainer.classList.add('free-shipping-bar__visible');
            } else {
              this.progressBar.classList.remove('free-shipping-bar__complete');
              this.progressMessageContainer.classList.remove('free-shipping-bar__hidden');
              this.successMessageContainer.classList.remove('free-shipping-bar__visible');

              const remainingFormatted = this.formatMoney(remaining);
              this.messageElement.innerHTML =
                'You\'re <span class="free-shipping-bar__amount">' +
                remainingFormatted +
                '</span> away from free shipping!';
            }
          })
          .catch((error) => console.error('Error fetching cart:', error));
      }

      formatMoney(cents) {
        return this.currencySymbol + (cents / 100).toFixed(2);
      }
    }
  );
}
